import * as React from "react";
import { Component } from "react";
import styles from "../../../styles/flyouts/superadmin/boq_supply_types/Properties.scss";
import * as _ from "lodash";
import { withRouter } from "react-router";
import autobind from "autobind-decorator";
import {__, validateForm} from "../../../core/utils";
import { setNotification } from "../../../redux/actions/general/notification";
import { listBoqSupplyTypes, updateBoqSupplyType } from "../../../redux/actions/table/superadmin/boq_supply_types";
import EditBOQSupplyTypeForm from "../../../forms/superadmin/boq_supply_types/EditBOQSupplyTypeForm";

@withRouter
class Properties extends Component {
    @autobind
    _handleSubmit(formData) {
        return validateForm(
            updateBoqSupplyType(formData.id, _.omit(formData, ['id'])).then(() => {
                listBoqSupplyTypes();

                this.props.readAction(formData.id);

                setNotification(__('properties.notifications.properties-have-been-saved'));
            })
        );
    }

    render() {
        const { data } = this.props;

        return (
            <div className={styles.scroller}>
                <EditBOQSupplyTypeForm
                    onSubmit={this._handleSubmit}
                    initialValues={{
                        ..._.pick(data, ['id', 'name', 'boq_supply_type_group_id']),
                    }}
                />
            </div>
        );
    }
}

export default Properties;
